import useGameStore from "../../lib/store/GameStore";
import usePersistentStore from "../../lib/store/PersistentStore";
import { BaseDialog } from "./BaseDialog";
import { useT } from "../../i18n/LocaleContext";

function HowToPlayDialog() {
  const t = useT();
  const [isHelpOpen, setIsHelpOpen] = useGameStore((state) => [
    state.isHelpOpen,
    state.setIsHelpOpen,
  ]);

  const [instructionsDismissed, saveInstructionsDismissed] = usePersistentStore(
    (state) => [state.instructionsDismissed, state.saveInstructionsDismissed]
  );

  const isOpen = isHelpOpen; // || !instructionsDismissed;

  function closeModal() {
    saveInstructionsDismissed(true);
    setIsHelpOpen(false);
  }

  return (
    <>
      <BaseDialog
        isOpen={isOpen}
        closeModal={closeModal}
        modalTitle={t("help.title")}
        modalBody={<HowToPlayBody />}
      />
    </>
  );
}

export const HELP_KEYS = [
  "help.guesses",
  "help.select",
  "help.types",
  "help.other",
  "help.rarity",
  "help.undo",
  "help.once",
  "help.daily",
];

function HowToPlayBody() {
  const t = useT();

  return (
    <div className="my-2 px-2 pt-2 text-md sm:px-4">
      <ul className="list-none space-y-5">
        {HELP_KEYS.map((key) => (
          <li key={key}>{t.rich(key)}</li>
        ))}
      </ul>
    </div>
  );
}

export default HowToPlayDialog;
